import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderLoadTenderHistory extends Layout {
    buttonTenderClassic: Button;
    sourceEdiOrder: DataSource;
    sourceEdiorderProfile: DataSource;
    table1: Table;
}
